export const NEWSLETTER_SIGNUP_STYLES = {
  root: "w-full min-h-[200px] md:min-h-[160px]",
  card: "flex flex-col items-center gap-5 overflow-hidden rounded-[16px] bg-gradient-to-r from-ticketon-dark-blue to-ticketon-blue p-6 md:flex-row md:gap-8 md:p-8",
  imageWrapper:
    "relative hidden h-[140px] w-[140px] shrink-0 overflow-hidden rounded-[12px] md:block",
  image: "h-full w-full object-cover",
  content: "flex flex-1 flex-col gap-2 text-center md:text-left",
  title: "text-[20px] md:text-[24px] font-bold text-white",
  description: "text-[13px] md:text-[14px] text-white/90",
  form: "mt-2 flex flex-col gap-2 sm:flex-row",
  emailLabel: "sr-only",
  input:
    "flex-1 rounded-[8px] border border-transparent bg-white px-3 py-2.5 text-[14px] text-ticketon-dark-text placeholder:text-ticketon-gray-alt focus:border-ticketon-lighter-blue focus:outline-none",
  cta: "inline-flex items-center justify-center rounded-[8px] bg-orange-dark px-6 py-2.5 text-[14px] font-semibold text-white transition-colors hover:bg-orange-dark-hover",
  disclaimer: "mt-2 text-[11px] text-white/70",
} as const;
